import { graphql } from '../gql';

export const getManifests = graphql(`
  query GetManifests {
    getTodayDeliveryManifests {
      deliveryManifests {
        confirmUrl
        downloadPdfUrl
        manifestTime
        readyAndBaggedTime
        restaurantName
        status
        version
        confirmationToken
        confirmationPreview
        manifestId
      }
      error {
        code
        message
      }
    }
  }
`);
